import React, { useEffect, useState } from "react";
import {
  Image,
  Platform,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
  ActivityIndicator,
} from "react-native";
import { Entypo } from "@expo/vector-icons";
import { StackActions } from "@react-navigation/native";
import BackgroundAdmin from "../components/BackgroundAdmin";
import Title from "../components/Title";
import Logo from "../components/Logo";
import ButtonLayout from "../components/ButtonLayout";
import makeRequest from "../components/makeRequest";
import InputLayout from "../components/InputLayout";

export default function (props) {
  const [loading, setLoading] = useState(true);
  const [administradores, setAdministradores] = useState([]);
  const [email, setEmail] = useState("");
  const max = 15;
  useEffect(() => {
    const request = async () => {
      const response = await makeRequest("users/permisos", "get");
      if (response[0] == 200) setAdministradores(response[1]);
      setLoading(false);
    };
    request();
  }, [loading]);

  return (
    <BackgroundAdmin scroll={true}>
      <Logo navigation={props.navigation}></Logo>
      <Title>Permisos</Title>
      {loading ? (
        <ActivityIndicator
          size='large'
          color='rgba(255,255,255, 0.6)'
          style={{ marginTop: 5 }}
        />
      ) : (
        <View style={{ flex: 1, justifyContent: "space-between" }}>
          <View>
            {administradores.length == 0 && (
              <Title style={{ fontSize: 14 }}>
                No ha añadido administradores todavía
              </Title>
            )}
          </View>
          <ScrollView style={{ flex: 1 }}>
            {administradores.map((e) => (
              <View
                key={e._id}
                style={{
                  margin: 10,
                  flexDirection: "row",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  borderRadius: 20,
                  justifyContent: "space-between",
                }}>
                <Text
                  style={{
                    margin: 15,
                    fontFamily: "Nunito-Regular",
                    color: "#3E4672",
                    fontSize: 16,
                    textAlign: "left",
                  }}>
                  {e.nombre} {e.apellido + "\n"}
                  {e.email}
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const response = await makeRequest(
                      "users/permisos/delete",
                      "post",
                      {
                        email: e.email,
                      }
                    );
                    setLoading(true);
                  }}
                  style={{
                    height: 30,
                    width: 30,
                    margin: 10,
                    backgroundColor: "white",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 30,
                    alignSelf: "center",
                  }}>
                  <Entypo name='cross' size={30} color='red' />
                </TouchableOpacity>
              </View>
            ))}
          </ScrollView>
          {administradores.length < max && (
            <>
              <View>
                <InputLayout
                  value={email}
                  onChangeText={setEmail}
                  placeholder='Correo electrónico'></InputLayout>
                <ButtonLayout
                  style={{ width: 150 }}
                  text='Añadir'
                  onPress={async () => {
                    const response = await makeRequest(
                      "users/permisos",
                      "post",
                      {
                        email: email,
                      }
                    );
                    if (
                      response[0] == 200 &&
                      administradores.filter((e) => e._id == response[1]._id)
                        .length == 0
                    )
                      setAdministradores([...administradores, response[1]]);
                  }}></ButtonLayout>
              </View>
            </>
          )}
        </View>
      )}
    </BackgroundAdmin>
  );
}
